import axios from "axios";
import Config from "../../../config";

const v2_actionGetLayoutConfig = (clienteId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${clienteId}/crm/layout-config`
    });
};

export default v2_actionGetLayoutConfig;
